<template>
  <v-container>
    <v-row class="ma-0 pa-0 pt-6" align="center" justify="center">
      <v-slider
        step="10"
        v-model="updatedProgress"
        thumb-label="always"
        :thumb-size="24"
        color="primary"
        track-color="#979797"
        :disabled="disabled"
      ></v-slider>
    </v-row>
    <v-row class="ma-0">
      <v-textarea
        :disabled="disabled"
        filled
        placeholder="Add notes"
        v-model="updatedNotes"
      ></v-textarea>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    progress: {
      type: Number,
      default: 0
    },
    notes: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      updatedProgress: this.progress,
      updatedNotes: ''
    }
  },
  watch: {
    updatedProgress(newVal) {
      this.$emit('update:progress', newVal)
    },
    updatedNotes(newVal) {
      this.$emit('update:notes', newVal)
    }
  }
}
</script>
